import React from "react";

const FooterItem = ({link}) => {
    return (
        <li>
            <div
                id={link.id}
                className="footer-nav-container__link"
                data-type={link.type}
            >
                {link.label}
            </div>
        </li>
    )
}

export default FooterItem;